import { path, pick, pipe } from 'ramda'
import { useSelector } from 'react-redux'

const useBasic = values => useSelector(pipe(path(['basic']), pick(values)))

export default useBasic
